export default __webpack_public_path__ + "fb07a3f4da825a4b177934aac6504144.svg";